import Cookies from 'universal-cookie';

import { CookiesKeys } from '../enums/cookies-keys.enum';

export const removeAuthenticationCookies = () => {
  new Cookies().remove(CookiesKeys.isTorusUsed, { path: '/' });
  new Cookies().remove(CookiesKeys.csrftoken, { path: '/' });
  new Cookies().remove(CookiesKeys.walletAddress, { path: '/' });
};
